import React from 'react';
import { LinePageHeaderContainer } from './LinePageHeader.elements';
import { PageHeader } from 'components';
import { useLineInfo } from '../../providers/useLineInfoProvider';

export const LinePageHeader = (): JSX.Element => {
  const { lineData, isLineDataLoading, lineId, plantData } = useLineInfo();
  const breadCrumbSettings = {
    paths: {
      customer: {
        label: plantData?.name,
        isLoading: !plantData
      },
      site: {
        label: plantData?.siteName,
        isLoading: !plantData,
        slug: `/fleet/site/v2/${lineData?.plantId}`
      },
      line: {
        label: lineData?.name,
        isLoading: isLineDataLoading,
        slug: `/fleet/line/v2/${lineId}`
      }
    }
  };
  return (
    <LinePageHeaderContainer>
        <PageHeader heading={''} breadCrumbSettings={breadCrumbSettings} />
    </LinePageHeaderContainer>
  );
};
